import { DateTime } from 'luxon';
import { Residence } from 'front-office/view-models/release-id-card/residence';
import { SubjectData } from 'shell/models/person';

export const transformResidence = (subjectData?: SubjectData): Residence => {
  if (!subjectData?.residenza || subjectData?.residenza.length === 0) {
    return {};
  }
  const [residence] = subjectData?.residenza || [];
  return {
    type: residence?.tipoIndirizzo || '',
    effectiveDate: residence?.dataDecorrenzaResidenza
      ? DateTime.fromISO(residence?.dataDecorrenzaResidenza)
      : null,
    municipality: residence?.indirizzo?.comune?.nomeComune || '',
    province: residence?.indirizzo?.comune?.siglaProvinciaIstat || '',
    istatCode: residence?.indirizzo?.comune?.codiceIstat || '',
    cap: residence?.indirizzo?.cap || '',
    location: residence?.indirizzo?.comune?.descrizioneLocalita || '',
    at: residence?.presso || '',
    capForeign: residence?.localitaEstera?.indirizzoEstero?.cap || '',
    civicCode: residence?.indirizzo?.numeroCivico?.codiceCivico,
    color: residence?.indirizzo?.numeroCivico?.colore,
    code: residence?.indirizzo?.numeroCivico?.codiceCivico,
    court: residence?.indirizzo?.numeroCivico?.civicoInterno?.corte,
    exponent: residence?.indirizzo?.numeroCivico?.esponente1,
    exponentFirstIntern: residence?.indirizzo?.numeroCivico?.civicoInterno?.espInterno1,
    exponentSecondaryIntern: residence?.indirizzo?.numeroCivico?.civicoInterno?.espInterno2,
    externalScale: residence?.indirizzo?.numeroCivico?.civicoInterno?.scalaEsterna,
    firstIntern: residence?.indirizzo?.numeroCivico?.civicoInterno?.interno1,
    secondaryIntern: residence?.indirizzo?.numeroCivico?.civicoInterno?.interno2,
    floor: residence?.indirizzo?.numeroCivico?.civicoInterno?.piano,
    metric: residence?.indirizzo?.numeroCivico?.metrico,
    letter: residence?.indirizzo?.numeroCivico?.lettera,
    name: residence?.indirizzo?.toponimo?.denominazioneToponimo,
    nui: residence?.indirizzo?.numeroCivico?.civicoInterno?.nui || '',
    scale: residence?.indirizzo?.numeroCivico?.civicoInterno?.scala || '',
    locationForeign:
      residence?.localitaEstera?.indirizzoEstero?.localita?.descrizioneLocalita || '',
    provinceForeign: residence?.localitaEstera?.indirizzoEstero?.localita?.provinciaContea || '',
    state: residence?.localitaEstera?.indirizzoEstero?.localita?.descrizioneStato || '',
    nameForeign: residence?.localitaEstera?.indirizzoEstero?.toponimo?.denominazione || '',
    civicNumber: residence?.localitaEstera?.indirizzoEstero?.toponimo?.numeroCivico || '',
    consulateCode: residence?.localitaEstera?.consolato?.codiceConsolato || '',
    consulate: residence?.localitaEstera?.consolato?.descrizioneConsolato || '',
    isolated: residence?.indirizzo?.numeroCivico?.civicoInterno?.isolato || '',
    kind: residence?.indirizzo?.toponimo?.specie || '',
    kindCode: residence?.indirizzo?.toponimo?.codSpecie || '',
    kindSource: residence?.indirizzo?.toponimo?.specieFonte || '',
    number: residence?.indirizzo?.numeroCivico?.numero || '',
    prog: residence?.indirizzo?.numeroCivico?.progSNC || '',
    source: residence?.indirizzo?.toponimo?.toponimoFonte || '',
    sourceCivic: residence?.indirizzo?.numeroCivico?.civicoFonte,
    secondary: residence?.indirizzo?.numeroCivico?.civicoInterno?.secondario,
  };
};
